(function () {
  'use strict';

  angular.module('wsLrs.services').
  /**
   *  CSV related utilities
   **/
  factory('CsvUtils', ['ConfirmModal', function (ConfirmModal) {
    return {
      // utility to prepare a raw value for insertion into csv string
      //
      toCsvString: function toCsvString(v) {
        // escape embedded quotes with extra quote, or replace null/undefined with empty string                     
        var value = typeof v !== 'undefined' && v !== null ? String(v).replace(/"/g, '""') : '';
        // wrap value in quotes
        return '"' + value + '"';
      },
      // Parameters:
      //  scope: a scope instance to be used for modal confirmation
      //  csvData: comma-separated, quote-wrapped string
      //  filename: optional name of file, with or without the .csv extension
      //            FEATURE: Can take a phrase/string, such as the title of a card, and will convert it to
      //            a useful filename by removing non-alphanumeric chars and spaces.
      //            Truncates long strings at 24 chars.  Default = 'download.csv'
      //
      downloadCsv: function downloadCsv(scope, csvData, filename) {
        var mimeType = 'text/csv;charset=utf-8;',
          csvBlob = new Blob([csvData], {
            type: mimeType
          }),
          link = null;
        var cleanup = function cleanup() {
          csvBlob = null;
          if (link) {
            document.body.removeChild(link);
            link = null;
          }
        };

        // lodash-like string utils
        var endsWith = function endsWith(str, ending) {
          var lenEnding = ending ? ending.length : 0;
          return str.substr(-lenEnding) === ending;
        };
        var kebabCase = function kebabCase(str) {
          var upper = '[A-Z]',
            lower = '[a-z]',
            digit = '[0-9]',
            up2camel = '(?:' + upper + '+)(?=' + upper + '{1}' + lower + ')',
            up2digit = '(?:' + upper + '+)(?=' + digit + ')',
            lo2other = '(?:' + lower + '+)(?=' + upper + '|' + digit + ')',
            num2other = '(?:' + digit + '+)(?=' + upper + '|' + lower + ')',
            split = '(' + up2camel + '|' + up2digit + '|' + lo2other + '|' + num2other + ')',
            kebab = str.replace(new RegExp(split, 'g'), '$1 ');
          kebab = kebab.toLowerCase();
          kebab = kebab.replace(/[^a-z]+/g, ' ');
          kebab = kebab.trim();
          return kebab.replace(/\s+/g, '-');
        };
        var trunc = function trunc(str, options) {
          var sep = options && 'separator' in options ? options.separator : ' ',
            len = options && 'length' in options ? options.length : 30,
            res = str.slice(0, len),
            loc = res.lastIndexOf(sep);
          return len < str.length && loc > 0 ? res.slice(0, loc) : res;
        };

        // create a usable filename from provided filename string
        var csvFilename = 'download.csv';
        if (filename) {
          csvFilename = endsWith(filename, '.csv') ? filename.slice(0, -4) : filename;
          csvFilename = kebabCase(csvFilename); // e.g., 'My Card Title' becomes 'my-card-title'
          csvFilename = trunc(csvFilename, {
            length: 24,
            separator: '-'
          }) + '.csv';
        }

        // use msSaveBlob in IE10+
        if (navigator.msSaveBlob) {
          navigator.msSaveBlob(csvBlob, csvFilename);
          cleanup();
          return;
        }

        // download via a (nearly) invisible anchor link
        link = document.createElement('a');
        link.innerHTML = 'downloading...';
        link.setAttribute('href', URL.createObjectURL(csvBlob));
        document.body.appendChild(link); // required for Firefox

        // if support for HTML5 download attribute
        if ('download' in link) {
          link.setAttribute('download', csvFilename);
          link.click();
          cleanup();
          return;
        }

        // all other browsers download via new window
        link.setAttribute('target', '_blank');

        // use confirmModal to inform user of new window download (with option to cancel)
        var modal = {
          title: 'CSV Download',
          body: 'The CSV data will open in a new tab.\n\n' + 'Use your browser\'s "Save As..." function to save the data as a .csv file',
          confirmBtn: 'Open CSV data in new tab',
          confirm: function confirm() {
            link.click();
            cleanup();
          },
          cancel: function cancel() {
            cleanup();
          }
        };
        ConfirmModal.open(scope, modal);
      }
    };
  }]);
})();
